<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_5"><span>Prologue</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_No"><span style=" font-style: italic; font-size: 1.00em;">November, 2014</span></p>
<p class="P_Normal__And__Left_Indent"> </p>
<p class="P_Normal__And__Left_Indent"><span style=" font-size: 0.93em;">EVERYTHING SEEMED</span> to be happening in slow motion.</p>
<p class="P_Normal">The casket team met the hearse, then carried the flag-draped coffin to the graveside. They lowered it with reverence to the stands provided before taking a step back while the firing party moved into position, everyone moving with slow military pace and precision.</p>
<p class="P_Normal">The wind was so cold, it bit into the bone.</p>
<p class="P_Normal">The casket team stood guard, having moved to a position several feet from the grave, their faces impassive as the ceremony took place.</p>
<p class="P_Normal"><span style=" font-style: italic; font-size: 1.00em;">Did some of them know him?</span></p>
<p class="P_Normal">The words of the service barely registered, and all of a sudden it was over, and those who’d carried the casket lined up on either side of it, facing each other. Silence fell, only to be shattered by a loud command. Three rounds pierced the air, and somewhere a bugler played taps.</p>
<p class="P_Normal">It was “lights out” indeed for the casket’s occupant.</p>
<p class="P_Normal">The casket team began to fold the flag, starting with the red-striped end, passing it precisely on each fold to the next two soldiers, a ballet of nimble hands that folded the fabric until no red was visible.</p>
<p class="P_Normal">At last it was handed to the officer in charge, who stepped forward to stand in front of the row of black suits and dresses. The words were spoken quietly, competing with the icy wind that stirred hair and clothing alike.</p>
<p class="P_Normal">“I present this flag to you on behalf of the president, the secretary of the Army, and with the thanks of a grateful nation for his service.” The officer then released the tightly folded flag to the family and saluted before taking one step back to rejoin the casket team.</p>
<p class="P_Normal">And then it was over.</p>
<p class="P_Normal">Another life lost.</p>
<p class="P_Normal">Only one thought dominated.</p>
<p class="P_Normal"><span style=" font-style: italic; font-size: 1.00em;">This has to stop.</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0005.vue?7df5e0b4